import React, { useState } from "react";
import PropTypes from "prop-types";
import { ModalView, Button } from "../../simple";

import styles from "./confirm-modal.module.scss";

const initialMessage = `{title:"Are you sure you want to close the form?", description: "In case of closing the form, the data will not be saved. Commodo sollicitudin viverra."}`;

export default function ConfirmModal({ message = initialMessage, callback }) {
  const [isConfirmModal, setConfirmModal] = useState(true);
  const { title, description } = JSON.parse(message);
  return (
    <ModalView
      isOpen={isConfirmModal}
      changeModalState={() => {
        callback(false);
        setConfirmModal(!isConfirmModal);
      }}
    >
      <h2 className={`title ${styles.title}`} style={{ marginBottom: "30px" }}>
        {title}
      </h2>
      <p className={`description ${styles.description}`}>{description}</p>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          margin: "30px 0"
        }}
      >
        <Button
          onClick={() => {
            callback(true);
            setConfirmModal(!isConfirmModal);
          }}
          className="button justify-content-center mr-3"
        >
          Confirm
        </Button>
        <Button
          onClick={() => {
            callback(false);
            setConfirmModal(!isConfirmModal);
          }}
          className="button button-danger justify-content-center"
        >
          Decline
        </Button>
      </div>
    </ModalView>
  );
}

ConfirmModal.propTypes = {
  message: PropTypes.string.isRequired,
  callback: PropTypes.func.isRequired
};
